import HubDbasQuestionnaireModule from './HubDbasQuestionnaireModule'

export default HubDbasQuestionnaireModule
